// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__jrHdf","signatureButtonsRight":"ModalSign_signatureButtonsRight__3QEwg"};